export const DATA_VARIANT_OUTLINED = 'outlined';
